import { Injectable } from '@angular/core';

@Injectable()

export class Config {
  public appId = 'e7a9d874-69f2-4c63-906d-648b254d8e8b';
  public appSlug = 'leolanches';

  public siteId = '5c60bf35-339a-4953-a8da-c4ff26e23a52';

  public appName = 'Leo_Lanches';
  public allowOpenTable = true;
  public allowPickup = true;
  public allowDelivery = true;

  // public apiUrl = 'http://localhost:8886/app';
  public apiUrl = 'https://api.foodplus.com.br/app';
  public siteUrl = 'https://site.foodplus.com.br/';
  public showLogo = true;

  public showSearchBar = true;

  public showVariationImage = true;

  public connected: boolean;
}

export const OneSignalAppId = '';
export const OneSignalSenderId = '';
